import axios from 'axios'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  Accept: 'application/json',
  'Content-Type': 'application/json'
}
if (localStorage.getItem(process.env.VUE_APP_TOKEN)) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem(process.env.VUE_APP_TOKEN)
  $.ajaxSetup({
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem(process.env.VUE_APP_TOKEN)
    }
  })
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status && error.response.status === 401) {
    localStorage.removeItem(process.env.VUE_APP_TOKEN)
    localStorage.removeItem(process.env.VUE_APP_REFRESH_TOKEN)
    window.location.reload()
  }
  return Promise.reject(error)
})

export default axios
